//@flow
import React, { type Element, Component } from 'react';
import {
  RequiresActionDiv,
  CustomDefaultIcon,
  RequiresActionP,
  CustomBlueTextLink
} from './CommissionDueShowStyles';

type Props = {
  currencyName: string,
  currencyType: string,
  requiresCryptoWallet: boolean,
  requiresBankAccount: boolean
};
export default class RequiresAction extends Component<Props> {
  handleCrypto = () => (
    <RequiresActionP>
      We noticed there’s no {this.props.currencyName} wallet associated with
      this account, please add a
      <CustomBlueTextLink exact to="/account/crypto-wallets">
        {`${this.props.currencyName} wallet address`}
      </CustomBlueTextLink>
      so that we can send you the funds.
    </RequiresActionP>
  );

  handleFiat = () => (
    <RequiresActionP>
      We noticed there’s no bank account associated with this account, please
      add a
      <CustomBlueTextLink exact to="/account/bank-account">
        bank account
      </CustomBlueTextLink>
      so that we can send you the funds.
    </RequiresActionP>
  );

  requiresAction = (Component: Element<any>) => (
    <RequiresActionDiv>
      <div>
        <CustomDefaultIcon name="warning" colorName={'red'} />
      </div>
      {Component}
    </RequiresActionDiv>
  );

  render() {
    const requiresCryptoWallet =
      this.props.requiresCryptoWallet && this.props.currencyType === 'crypto';
    const requiresBankAccount =
      this.props.requiresBankAccount && this.props.currencyType === 'fiat';
    if (requiresCryptoWallet) {
      return this.requiresAction(this.handleCrypto());
    } else if (requiresBankAccount) {
      return this.requiresAction(this.handleFiat());
    } else {
      return <div />;
    }
  }
}
